import $ from 'jquery';
// eslint-disable-next-line no-shadow

const updateVariationsDisplay = function () {
	// const updateElements = () => {
	setTimeout( () => {
		const priceWrapper = $( '.product-price-wrap' );
		const variation = $( this ).find( '.single_variation_wrap' );
		const price = variation.find( '.price' ).html();
		const availability = variation.find( '.stock' ).html();
		if ( price ) {
			$( '.product-price-wrap .price' ).html( price );
		}

		if ( availability ) {
			$( '.product-price-wrap .stock' ).html( availability );
		}
		priceWrapper.css( { opacity: 1 } );
	}, 500 );
	// };
};

export default updateVariationsDisplay;

// jQuery( document ).ready( function ( $ ) {
// 	function updateVariationsDisplay() {
// 		// console.log( 'changed' );
// 	}
// 	// Variable product - Update price display on attribute change
// 	$( 'form.variations_form' ).on(
// 		'woocommerce_variation_has_changed',
// 		updateVariationsDisplay
// 	);
// 	$( 'form.variations_form' ).on(
// 		'check_variations',
// 		updateVariationsDisplay
// 	);
// 	$( 'form.variations_form' ).on(
// 		'woocommerce_variation_has_changed',
// 		updateVariationsDisplay
// 	);
// } );
